import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel", type = "danger" }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const colorClasses = {
    danger: {
      icon: 'text-mongodb-red-dark2',
      iconBg: 'bg-mongodb-red-light3',
      button: 'bg-mongodb-red-dark2 hover:bg-mongodb-red-dark1',
    },
    warning: {
      icon: 'text-yellow-600',
      iconBg: 'bg-yellow-100',
      button: 'bg-yellow-600 hover:bg-yellow-700',
    },
    info: {
      icon: 'text-mongodb-green-dark2',
      iconBg: 'bg-mongodb-green-light3',
      button: 'bg-mongodb-green-dark2 hover:bg-mongodb-green-dark1',
    },
  };

  const colors = colorClasses[type] || colorClasses.danger;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full animate-fadeIn">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-mongodb-gray-light1">
          <div className="flex items-center gap-3">
            <div className={`${colors.iconBg} p-2 rounded-full`}>
              <AlertTriangle className={`w-6 h-6 ${colors.icon}`} />
            </div>
            <h2 className="text-xl font-bold text-mongodb-gray-dark3">{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="text-mongodb-gray-dark1 hover:text-mongodb-gray-dark3 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-mongodb-gray-dark2">{message}</p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 bg-mongodb-gray-light3 rounded-b-lg">
          <button
            onClick={onClose}
            className="px-4 py-2 text-mongodb-gray-dark2 bg-white border border-mongodb-gray-light1 rounded-lg hover:bg-mongodb-gray-light2 transition-colors font-medium"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={`px-4 py-2 text-white rounded-lg transition-colors font-medium ${colors.button}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

